import { render, staticRenderFns } from "./formQuestionAnswerP2h.vue?vue&type=template&id=381b88d2&scoped=true"
import script from "./formQuestionAnswerP2h.vue?vue&type=script&lang=js"
export * from "./formQuestionAnswerP2h.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "381b88d2",
  null
  
)

export default component.exports